import PrivacyToggle from "../../../../utils/PrivacyToggle/PrivacyToggle";
import "./PublicHeader.css";

const PublicHeader = ({
  profileUser,
  handleShare,
  userId,
  privacy,
  setPrivacy
}) => {

  if (!profileUser) return null;

  const isOwner = userId === profileUser.id;

  return (
    <div className="public-header">

      <div className="public-user-info">
        <h2>{profileUser.name}</h2>
        <span>@{profileUser.username}</span>
      </div>

      <div className="header-actions">

  {isOwner && (<PrivacyToggle
    userId={userId}
    privacy={privacy}
    setPrivacy={setPrivacy}
  />)}

  <button className="share-btn" onClick={handleShare}>
    ⤴
  </button>

</div>

    </div>
  );
};

export default PublicHeader;